import { URLS } from "../constants/url";
import AES from 'crypto-js/aes'
import { enc } from 'crypto-js'
import moment from "moment";
import { isEmpty } from "lodash";
import { IConcessionData, ITicketData } from "../models/payment";
import momentTimeZone from "moment-timezone";
import { ALLOWED_REGIONS, timezoneConfig } from "../constants/timezone";

export const downloadFile = (url: string, target?:string) => {
    const link = document.createElement("a");
    link.setAttribute("target", target?target:"_self");
    link.setAttribute("href", url);
    document.body.appendChild(link);
    link.click();
    link.remove();
}


export function ltrim(str: any) {
    if (!str) return str;
    return str.replace(/^\s+/g, "");
}


export const onImgError = (event: any) => {
    event.target.src = URLS.DEFAULT_FOOD_IMAGE;
};

export const yearArray = () => {
    const year = new Array(100).fill(1);
    return year.map((v, i) => {
        return {
            label: new Date().getFullYear() - i,
            value: `${new Date().getFullYear() - i}`
        }
    })
}

export const yearSignupArray = () => {
    const year = new Array(90).fill(1);
    return year.map((v, i) => {
        return {
            label: new Date().getFullYear() - (i + 13),
            value: `${new Date().getFullYear() - (i + 13)}`
        }
    })
}

export const futureYear = () => {
    const year = new Array(21).fill(1);
    return year.map((v, i) => {
        return {
            label: new Date().getFullYear() + i,
            value: `${new Date().getFullYear() + i}`
        }
    })
}

export const dateArray = () => {
    const dayArr = [];
    for (let i = 0; i <= 30; i++) {
        let value = (i + 1) < 10 ? `0${(i + 1)}` : `${(i + 1)}`;
        dayArr.push({
            label: value,
            value: value
        });
    }
    return dayArr;
}

export const monthArray = () => {
    const monthArr = [];
    for (let i = 0; i <= 11; i++) {
        let value = (i + 1) < 10 ? `0${(i + 1)}` : `${(i + 1)}`;
        monthArr.push({
            label: value,
            value: value
        });
    }
    return monthArr;
}

export const decryptData = (ciphertext: string, key: string) => {
    let bytes = AES.decrypt(ciphertext, key);
    let originalText = bytes.toString(enc.Utf8);
    return originalText;
};

export const encryptData = (text: string, key: string) => {
    let ciphertext = AES.encrypt(text, key).toString();
    return ciphertext;
};

export const sleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const numberOnly = (e: any) => {
    const { value } = e.target;
    const re = /^[0-9]+$/;
    if (value === "" || re.test(value)) {
        return value;
    }
}

export const validateEmail = (email: string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const shuffleArray = (data: any) => {
    return data.map((value: any) => ({ value, sort: Math.random() }))
        .sort((a: any, b: any) => a.sort - b.sort).slice(0, 5)
        .map((v: any) => v.value)
}

export const enableShowTime = (session: any, timeZone: string) => {
    if (session) {
        if (
            session.scheduledFor && session.scheduledFor !== '0000-00-00 00:00:00' && !isEmpty(session.scheduledFor)
        ) {
            return moment().utcOffset(timeZone).format('YYYY-MM-DD HH:mm:ss') >= moment(session.scheduledFor, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
        } else {
            return true;
        }
    }
};


export const movieSessAttriImages = (params: any): { image: string, desc: string } => {

  switch (params?params.toLowerCase():params) {
    case "imax 2d":
    case "imax":
      return { image: "imax_only.svg", desc: "" };
    case "imax dubbed":
      return { image: "imax_only.svg", desc: "English language dubbed" };
    case "imax subtitles":
      return { image: "imax_only.svg", desc: "English subtitles" };
    case "imax 3d":
      return { image: "imax_3d.svg", desc: "" };

    case "titan luxe":
      return { image: "titanluxe_only.svg", desc: "" };
    case "titan luxe dubbed":
      return { image: "titanluxe_only.svg", desc: "English language dubbed" };
    case "titan luxe subtitles":
      return { image: "titanluxe_only.svg", desc: "English subtitles" };
    case "titan luxe 3d":
      return { image: "titanluxe_Dolby_3d.svg", desc: "" };
    case "titan luxe with dolby atmos":
      return { image: "titanluxe_Dolby.svg", desc: "" };
    case "titan luxe dubbed with dolby atmos":
      return {
        image: "titanluxe_Dolby.svg",
        desc: "English language dubbed",
      };
    case "titan luxe subtitles with dolby atmos":
      return { image: "titanluxe_Dolby.svg", desc: "English subtitles" };

    case "titan xc":
      return { image: "titanxc_only.svg", desc: "" };
    case "titan xc dubbed":
      return { image: "titanxc_only.svg", desc: "English language dubbed" };
    case "titan xc subtitles":
      return { image: "titanxc_only.svg", desc: "English subtitles" };
    case "titan xc 3d":
      return { image: "titanxc_Dolby_3d.svg", desc: "" };
    case "titan xc with dolby atmos":
      return { image: "titanxc_Dolby.svg", desc: "" };
    case "titan xc dubbed with dolby atmos":
      return { image: "titanxc_Dolby.svg", desc: "English language dubbed" };
    case "titan xc subtitles with dolby atmos":
      return { image: "titanxc_Dolby.svg", desc: "English subtitles" };
    case "jaffe art theatre":
      return { image: "jaffe_banner_gold.svg", desc: "" };
    case "jaffe art theatre black":
      return { image: "jaffe_banner_black.svg", desc: "" };

    default:
      return { image: "", desc: "" };
  }
}

export const formatRefundTicket = (v:ITicketData)=>{
  return { SeatRowId: v.Seat_number?v.Seat_number.split(/\d/).shift():'', SeatNumber: v.Seat_number?v.Seat_number.split(/[A-Za-z]/).pop():'', RowId: v.Id, Ticket_price: v.Ticket_price, package_seat: v.package_seat, sequenceNumber: v.sequenceNumber }
}

export const formatRefundConcession = (v:IConcessionData)=>{
  return { ItemId: v.Item_id, RowId: v.Id, Price: v.Price, LineNumber: v.LineNumber }
}


export const getTimeZoneDetails = (countryId: string) => {
  const userTimezone = momentTimeZone.tz.guess();
  const validTimezones = timezoneConfig[countryId];

  return {
    userTimezone,
    validTimezones,
    includeUserTimeZone: validTimezones?.includes(userTimezone),
    length: validTimezones?.length
  }
}

export const findCurretRegion = () => {
  const userTimezone = momentTimeZone.tz.guess();
  let currentRegion;
  for(const i in ALLOWED_REGIONS){
    const validTimezones = timezoneConfig[ALLOWED_REGIONS[i]];
    if(validTimezones?.includes(userTimezone)){
      currentRegion = ALLOWED_REGIONS[i];
      break;
    }
  }
  return currentRegion;
}

export const getCookieByName = (name: string) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
    return null;
}